import Toggler from "../../../scripts/classes/Toggler";

var IconCard = function(options) {

    this.options = {
        $el: true,
    };

    $.extend(true, this.options, options);

};

IconCard.prototype.init = function() {
    this.toggler = new Toggler( this.options.$el );
    this.toggler.init();

};

export default IconCard;